import { ReactElement, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
    ActionButton,
    Loader,
    Modal,
    PageWrapper,
    SectionTitle,
    TableHeader,
    TableRow,
    TableWrapper
} from '../../../components'
import strings from '../../../locale/en'
import { updateDetailId } from '../../../redux/lesson/action'
import { getLesson, updateLessonPlane } from '../../../redux/lesson/api'
import { RootState } from '../../../redux/store'
import { tableHeader } from './const'
import LessonUpdate from './update'
import moment from 'moment'

const LessonPlane = (): ReactElement => {
    const {
        userDetailId = "",
        getLessonResponse,
        isLoading,
        updateLessonDetails,
        updateSelectedDetailId
    } = useSelector(
        (state: RootState) => ({
            userDetailId: state.user.userInfo?.userDetail.userDetailId,
            getLessonResponse: state.lesson.getLessonResponse,
            isLoading: state.lesson.isLoading,
            updateLessonDetails: state.lesson.updateLesson,
            updateSelectedDetailId: state.lesson.updateSelectedDetailId
        }),
        shallowEqual
    )

    const {
        menu: {
            lessonPlane: {
                title
            }
        }
    } = strings

    const dispatch = useDispatch()
    const [values, setValues] = useState(updateLessonDetails)
    const [showmodal, setShowModal] = useState('')


    useEffect(() => {
        dispatch(getLesson(userDetailId))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <PageWrapper>
            <SectionTitle title={title} hasBorder />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <TableWrapper>
                        <Table size='sm' responsive="sm">
                            <TableHeader>
                                <TableRow>
                                    {tableHeader?.map((header, index) => (
                                        <th key={`institute-list-header-${index}`}>{header}</th>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <tbody>
                                {getLessonResponse.map((data, index) => {
                                    const {
                                        chapter,
                                        course,
                                        subject,
                                        topic,
                                        detailAssignId,
                                        status,
                                        assignedDate,
                                        completionDate
                                    } = data
                                    return (
                                        <TableRow key={`user-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{assignedDate ? moment(assignedDate).format('DD-MM-yyyy') : '-'}</td>
                                            <td>{course}</td>
                                            <td>{subject}</td>
                                            <td>{chapter}</td>
                                            <td>{topic}</td>
                                            <td>{status}</td>
                                            <td>{completionDate ? moment(completionDate).format('DD-MM-yyyy') : '-'}</td>
                                            <td>
                                                <ActionButton
                                                    variant='outline-secondary'
                                                    onClick={() => {
                                                        setShowModal('knhj')
                                                        dispatch(updateDetailId({
                                                            detailAssignId: detailAssignId
                                                        }))
                                                    }}
                                                >
                                                    Update Status
                                                </ActionButton>
                                            </td>
                                        </TableRow>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </TableWrapper>
                </>
            )}
            {showmodal && (
                <Modal
                    handleCancel={() => {
                        setShowModal('')
                    }}
                    handleSubmit={() => {
                        dispatch(updateLessonPlane({
                            detailAssignId: `${updateSelectedDetailId?.detailAssignId}`,
                            status: values?.status,
                            date: values?.date
                        }))
                    }}
                    isLargeModal={true}
                    title="Lesson Update"
                >
                    <LessonUpdate values={values} setValues={setValues} />
                </Modal>
            )}
        </PageWrapper>
    )
}

export default LessonPlane